/**
 * C0-LOOK P5: contact shadow at the foot of stone blocks. A dithered ring one tile-fraction wider than
 * each block's footprint, under everything standing, so terraces and walls sit on the ground instead
 * of floating on it. Cool and dark, 2 steps (solid near the block, dithered out). Drawn once.
 */
import { registerRenderPass } from './registry';
import type { Prop } from '../terrain';

const BAY = [0, 8, 2, 10, 12, 4, 14, 6, 3, 11, 1, 9, 15, 7, 13, 5].map((v) => (v + 0.5) / 16);
let ring: HTMLCanvasElement | null = null;
const RW = 48;
const RH = 28;

function makeRing(): HTMLCanvasElement {
  const c = document.createElement('canvas');
  c.width = RW;
  c.height = RH;
  const g = c.getContext('2d')!;
  g.fillStyle = 'rgba(20,18,38,0.34)';
  for (let y = 0; y < RH; y++)
    for (let x = 0; x < RW; x++) {
      // diamond distance in units of the block's own footprint (1 = its edge)
      const td = Math.abs(x + 0.5 - RW / 2) / 16 + Math.abs(y + 0.5 - RH / 2 - 0.5) / 8;
      if (td < 1 || td > 1.42) continue;
      const t = (td - 1) / 0.42;
      if (t > 0.45 && BAY[(y & 3) * 4 + (x & 3)]! < (t - 0.45) / 0.55) continue;
      g.fillRect(x, y, 1, 1);
    }
  return c;
}

const CACHE = new WeakMap<readonly Prop[], Prop[]>();

registerRenderPass({
  id: 'contactAO',
  layer: 'ground',
  order: 305,
  draw(f) {
    if (!f.outdoors) return;
    const props = f.outdoors.props.props;
    let list = CACHE.get(props);
    if (!list) CACHE.set(props, (list = props.filter((p) => p.ao)));
    ring ??= makeRing();
    const { g, ox, oy, W, H } = f;
    g.save();
    for (const p of list) {
      const cx = Math.round(p.x + p.img.width / 2 + ox);
      const cy = Math.round(p.y + p.img.height - 8 + oy);
      if (cx < -RW || cx > W + RW || cy < -RH || cy > H + RH) continue;
      g.drawImage(ring, cx - RW / 2, cy - RH / 2);
    }
    g.restore();
  },
});
